import $ from 'jquery';
import { alert, defaultModules } from '@pnotify/core';
import * as PNotifyMobile from '@pnotify/mobile';

defaultModules.set(PNotifyMobile, {});

$('#js-province').on('select2:select', function (e) {
  var data = e.params.data;
  if (!data?.id) {
    return;
  }

  $('#js-error-province').html('');
  setInputLocation(data?.text, '', '');
  $('#js-district').empty();
  $('#js-district').val('ALL');
  $('#js-wards').empty();
  $('#js-wards').val('ALL');
  fetchCart('GET', `/api/location/district/${data.id}`, null, (res) => {
    if (res) {
      $('#js-district').select2({
        data: [
          { id: 'ALL', text: 'Chọn Quận/Huyện' },
          ...res?.data?.map((e) => ({ id: e.id, text: e.name })),
        ],
      });
    }
  });
});

$('#js-district').on('select2:select', function (e) {
  var data = e.params.data;
  if (!data?.id) {
    return;
  }

  $('#js-error-district').html('');
  setInputLocation(null, data?.text, '');
  $('#js-wards').empty();
  $('#js-wards').val('ALL');
  fetchCart('GET', `/api/location/wards/${data.id}`, null, (res) => {
    if (res) {
      $('#js-wards').select2({
        data: [
          { id: 'ALL', text: 'Chọn Phường/Xã' },
          ...res?.data?.map((e) => ({ id: e.id, text: e.name })),
        ],
      });
    }
  });
});

$('#js-wards').on('select2:select', function (e) {
  var data = e.params.data;
  if (!data?.id) {
    return;
  }

  $('#js-error-wards').html('');
  setInputLocation(null, null, data?.text);
});

function setInputLocation(province = null, district = null, wards = null) {
  if (province !== null) {
    $('#js-order-form input[name="province_name"]').val(province);
  }
  if (district !== null) {
    $('#js-order-form input[name="district_name"]').val(district);
  }
  if (wards !== null) {
    $('#js-order-form input[name="wards_name"]').val(wards);
  }
}

const handleAscDescNumber = (id, type, total, typeCheck = null) => {
  if ((type === 'DESC' && total <= 1) || (type === 'ASC' && total >= 999)) {
    return;
  }

  let result = 1;
  if (type === 'DESC') {
    result = Number(total) - 1;
  } else if (type === 'ASC') {
    result = Number(total) + 1;
  }

  $(`.minus-plus-quantity[data-id="${id}"]`).val(result);
  if (typeCheck !== 'CART') {
    return;
  }

  fetchCart(
    'PUT',
    '/api/cart/update',
    {
      id: id,
      quantity: result,
    },
    (res) => {
      if (res) {
        const currentItem = res?.find((e) => e.id === id);
        const sum = res?.reduce(
          (result, currentValue) => Number(result) + Number(currentValue.total),
          0,
        );
        $('#js-show-item-total-' + id).html(
          `${currentItem?.total?.toLocaleString('en-US')}đ`,
        );
        showTotal(sum);
      }
    },
    () => {
      notificationCart('notice', 'Cập nhật không thành công');
    },
  );
};

$('.decrease-quantity').on('click', (e) => {
  const dataId = e?.target?.dataset?.id;
  const type = e?.target?.dataset?.type;
  const currentValue = $(`.minus-plus-quantity[data-id="${dataId}"]`).val();
  handleAscDescNumber(dataId, 'DESC', currentValue, type);
});

$('.increase-quantity').on('click', (e) => {
  const dataId = e?.target?.dataset?.id;
  const type = e?.target?.dataset?.type;
  const currentValue = $(`.minus-plus-quantity[data-id="${dataId}"]`).val();
  handleAscDescNumber(dataId, 'ASC', currentValue, type);
});

$('.js-product-remove').on('click', (e) => {
  e.preventDefault();
  const id = e?.currentTarget?.dataset?.id;
  if (!id) {
    return;
  }

  fetchCart(
    'DELETE',
    `/api/cart/${id}`,
    null,
    (res) => {
      if (res?.status) {
        notificationCart('success', 'Đã xóa 1 sản phẩm trong giỏ hàng');
        const countCart = res?.data?.length || 0;
        if (countCart === 0) {
          window.location.reload();
          return;
        }

        const sum = res?.data?.reduce(
          (result, currentValue) => Number(result) + Number(currentValue.total),
          0,
        );
        $(`.js-row-cart[data-id=${id}]`).hide();
        showTotal(sum);
        $('#js-head-show-cart-total').html(countCart);
      }
    },
    () => {
      notificationCart('notice', 'Lỗi hệ thống');
    },
  );
});

$('#js-list-radio-attribute input[type="radio"]').on('click', (e) => {
  $('#js-error-attribute').html('');
  const dataValue = JSON.parse(e?.target?.dataset?.value) || null;
  if (dataValue) {
    const htmlStrong = document.createElement('strong');
    htmlStrong.innerHTML = dataValue?.price
      ? `${dataValue?.price?.toLocaleString('en-US')}đ`
      : 0;
    $('#js-detail-price').empty();
    $('#js-detail-price').append(htmlStrong);
    $('#js-detail-old-price').hide();
    if (dataValue?.code) {
      $('#js-detail-code').html(dataValue?.code);
    }
  }
});

$('.js-add-cart-detail').on('click', (e) => {
  e.preventDefault();
  const isViewCarts = e?.currentTarget?.dataset?.isViewCarts;
  let attributeId = null;
  const form = $('#js-form-add-cart-detail').serializeArray();
  const isAttribute = form?.find((e) => e.name === 'is_attribute')?.value;
  attributeId = form?.find((e) => e.name === 'attribute_id')?.value;
  if (isAttribute && !attributeId) {
    $('#js-error-attribute').html('Chọn 1 loại muốn thêm vào giỏ');
    return;
  }

  fetchCart(
    'POST',
    '/api/cart/add',
    {
      id: form?.find((e) => e.name === 'id')?.value,
      quantity: form?.find((e) => e.name === 'quantity')?.value,
      attributeId: attributeId,
    },
    (res) => {
      if (res?.status) {
        notificationCart('success', '1 sản phẩm đã vào giỏ');
        const countCart = res?.data?.length || 0;
        $('#js-head-show-cart-total').html(countCart);
        if (isViewCarts) {
          return (window.location.href = '/gio-hang.html');
        }
      }
    },
    () => {
      notificationCart('notice', 'Lỗi hệ thống');
    },
  );
});

function showTotal(value = 0) {
  $('#js-show-all-total').html(`${value?.toLocaleString('en-US')}đ`);
  return;
}

function fetchCart(
  method = 'GET',
  endpoint = '',
  data,
  onDone = () => {},
  onFail = () => {},
  always = () => {},
) {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  });
  $.ajax({
    method: method,
    url: endpoint,
    data: data,
    cache: false,
  })
    .done(function (res) {
      onDone(res);
    })
    .fail(function (res) {
      onFail(res);
    })
    .always(function (res) {
      always(res);
    });
}

function notificationCart(type = 'success', text = false, title = false) {
  return alert({
    title: title,
    text: text,
    type: type,
    animateSpeed: 'normal',
    delay: 2000,
    hide: true,
    mouseReset: true,
    closerHover: true,
    sticker: false,
  });
}
